export const cleanQueryString = () => {
  const url = new URL(`${window.location.href}`)
  url.search = ''
  window.history.replaceState({}, document.title, url.toString())
}

export const getPaymentRoute = (gateway: string): string => {
  if (gateway === 'revolut') return 'payment-revolut'
  if (gateway === 'stripe') return 'payment-stripe'
  return 'payment'
}
